module.exports = __webpack_public_path__ + "static/media/disappointed-emoji-emoticon-emotion-face-sad-svgrepo-com.108da9a8.svg";